import React from "react";

import Switch from "antd/es/switch";
import { useIntl } from "react-intl";

import formatPrice from "../../util/formatPrice";
import { SavingsInformation } from "../../util/useSavingsInformation";

import styles from "./AnnualSwitch.module.scss";

interface Props {
  disabled?: boolean;
  isAnnual: boolean;
  onChange?: (isAnnual: boolean) => void;
  savingsInformation: SavingsInformation;
}

const AnnualSwitch: React.FC<Props> = ({ disabled, isAnnual, onChange, savingsInformation }) => {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      <span className={styles.label}>
        {intl.formatMessage(
          {
            id: "billing.licenses.price.type",
            defaultMessage: "Annual Pricing{canSave, select, true { (Save {amount})} other {}}",
            description: "Annual pricing switch label on Billing page",
          },
          {
            amount: formatPrice(intl, savingsInformation.savingPrice),
            canSave: savingsInformation.canSave,
          }
        )}
      </span>
      <Switch checked={isAnnual} disabled={disabled} onChange={onChange} size="small" />
    </div>
  );
};

export default AnnualSwitch;
